import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * Mobile-friendly "Volver" button shown on inner pages.
 * - Hidden on the landing ("/").
 * - On mobile only (md:hidden), to keep desktop clean.
 * - Uses window.history.back() so it works whether the user navigated
 *   in-app or arrived through SoftBack's phantom entry.
 * - Falls back to home if there's literally no history to go back to.
 */
export default function MobileBackBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  const handleBack = () => {
    // If we have a real previous entry, use it.
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div
      className="md:hidden sticky top-[64px] z-30 bg-white/85 backdrop-blur border-b border-border"
      data-testid="mobile-back-bar"
    >
      <button
        type="button"
        onClick={handleBack}
        className="flex items-center gap-1.5 text-sm text-zinc-700 hover:text-[#7C3AED] active:text-[#5B21B6] px-4 py-2.5 font-medium"
        data-testid="mobile-back-btn"
      >
        <ChevronLeft className="w-5 h-5" />
        Volver
      </button>
    </div>
  );
}
